import { useLayoutEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const PageWrapper: React.FC = ({ children }) => {
  const location = useLocation();
  const scrollRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    scrollRef.current?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  return (
    <div ref={scrollRef} className="min-w-[300px] h-full overflow-auto">
      {children}
    </div>
  );
};
